import type { LocationCreateProps } from "./location-create.type";
import type { LocationCreatePayload } from "@/entities/location";
import type { LocationFormValues } from "@/modules/location/location-form/";

import { useTranslation } from "react-i18next";

import { useCreateLocation } from "@/entities/location";
import { useNavigateToRessource } from "@/hooks/useNavigateToRessource";
import LocationForm from "@/modules/location/location-form";
import { MAP_DEFAULT_CENTER_STRING } from "@/modules/map";

const LocationCreate = ({ parentLocation }: LocationCreateProps) => {
  const { t } = useTranslation();
  const mutation = useCreateLocation();

  const initialValues: LocationFormValues = {
    name: "",
    description: "",
    coordinate: parentLocation?.coordinate || MAP_DEFAULT_CENTER_STRING,
    location: {
      value: parentLocation?.id,
      label: parentLocation?.name,
      key: parentLocation?.id,
    },
  };

  const onNavigateToLocation = useNavigateToRessource<LocationCreatePayload>(
    "location",
    (response) => response.data.data.id
  );

  return (
    <LocationForm
      mutation={mutation}
      saveButtonLabel={t("global:add")}
      initialValues={initialValues}
      onMutate={onNavigateToLocation}
      isSector={!!parentLocation} // Indicate this is a sector creation
    />
  );
};

export default LocationCreate;
